import Emoji from './emoji3000.json'
// const banWordsEmoji: { [key: string]: string[] } = {
//   cat: ['🐱','😎'],
//   dog: ['🐕'],
//   monkey: ['🐒'],
//   bird: ['🦆'],
//   pig: ['🐖'],
// };
const banWordsEmoji: { [key: string]: string[] } = Emoji
export default {
  banWordsEmoji,
};
